import { Link, useParams } from "react-router-dom";
import useAuth from "../../../../../hooks/useAuth";
import MobileForm from "../../../../../components/MobileForm";
import { makeStyles } from '@material-ui/core';
import { Box }  from '@material-ui/core';

const useStyles = makeStyles({
  formButton: {
    width: '30px',
    background: '#6271CB',
    color: 'white',
    borderRadius: 5,
    display: 'block',
    textDecoration: 'none',
    textAlign: 'center',
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 7,
    marginLeft: 20,
    marginRight: 20,
  }
});

const InspectionPage6 = () => {
  const styles = useStyles()
  const { version, appointmentId } = useParams();
  const useValidation = require(`./v${version}/useValidation`).default;
  const background = require(`./v${version}/background.png`);
  const fields = require(`./v${version}/fields.json`);
  const { width: bgWidth, height: bgHeight } = require(`./v${version}/dimensions.json`);

  const width = document.documentElement.clientWidth;
  const ratio = width / bgWidth;
  const newHeight = bgHeight * ratio;

  return (
    <div>
      <MobileForm
        type="inspectionPage6"
        version={version}
        width={width}
        height={newHeight}
        useValidation={useValidation}
        background={background}
        fields={fields}
      />
      <Box display="flex" flexDirection="row">
        <Link to={`/form/casinspection/${version}/1/${appointmentId}`} className={styles.formButton}>1</Link>
        <Link to={`/form/casinspection/${version}/2/${appointmentId}`} className={styles.formButton}>2</Link>
        <Link to={`/form/casinspection/${version}/3/${appointmentId}`} className={styles.formButton}>3</Link>
        <Link to={`/form/casinspection/${version}/4/${appointmentId}`} className={styles.formButton}>4</Link>
        <Link to={`/form/casinspection/${version}/5/${appointmentId}`} className={styles.formButton}>5</Link>
        <Link to={`/form/casinspection/${version}/7/${appointmentId}`} className={styles.formButton}>7</Link>
        <Link to={`/form/casinspection/${version}/8/${appointmentId}`} className={styles.formButton}>8</Link>
        <Link to={`/form/casinspection/${version}/9/${appointmentId}`} className={styles.formButton}>9</Link>
        <Link to={`/form/casinspection/${version}/10/${appointmentId}`} className={styles.formButton}>10</Link>
        <Link to={`/form/casinspection/${version}/11/${appointmentId}`} className={styles.formButton}>11</Link>
      </Box>
    </div>
  );
};

const Page = () => {
  const { PrivateContent } = useAuth();

  return (
    <PrivateContent title="CAS Inspection Page 6">
      <InspectionPage6 />
    </PrivateContent>
  );
};

export default Page;
